import { ViewChanger } from "./view-changer";
import { ServerSetup } from "./config";

const 
    viewChanger = new ViewChanger(),
    config = new ServerSetup();

let 
    shouldInitTables = true;

export class ViewManager {
    constructor() {

    }

    initTables() {
        if(shouldInitTables) {
            config.servers.forEach((server) => viewChanger.initTable(server.hostName, config.downloadsPerPing));
        }

        shouldInitTables = false;
    };

    updateTable(hostName, pingNumber, downloadSpeed, maxDownloadSpeed) {
        viewChanger.updateTable(hostName, pingNumber, downloadSpeed, maxDownloadSpeed);
    }

    updateServerRequestStatus(hostName, pingIndex, statusMassage) {
        viewChanger.updateServerRequestStatus(hostName, pingIndex, statusMassage);
    }

    addSummarizeUrl(url) {
        viewChanger.addSummarizeUrl(url);
    }

    initTablesFromUrl(serverList) {
        if(shouldInitTables) {
            serverList.forEach((server) => viewChanger.initTableFromUrl(server));
        }

        shouldInitTables = false;
    }

    updateUserInfo(userInfo) {
        viewChanger.updateUserInfo(userInfo)
    }
}